import CardGridPlaylist from "../CardGridPlaylist";
import styled from "styled-components/native";

interface Props {
	isVam?: boolean;
	slice?: number;
	load?: number;
	isExtras?: any;
	isNarrow?: boolean;
	isToggleMQTT?: boolean;
}

const LoaderContainer = styled.View<{ isNarrow: boolean; isVam: boolean; isToggleMQTT?: boolean }>`
	padding-left: ${(props) => (props.isNarrow && props.isVam && props.isToggleMQTT ? "250px" : "0px")};
`;

const AggregatePageLoader = (props: Props) => {
	const load = props.load ?? 24;

	const renderLoader = () => (
		<CardGridPlaylist
			data={[...Array(load)].slice(0, props.slice ?? load).map((index) => {
				return { parentProductId: index, packshots: null };
			})}
			hideBorder={true}
			isAggregate={true}
			isClips={props.isVam}
			disabled={true}
			isExtras={props.isExtras}
		/>
	);

	return (
		<>
			{props.isNarrow ? (
				//@ts-ignore
				<LoaderContainer isVam={props.isVam} isNarrow={props.isNarrow} isToggleMQTT={props.isToggleMQTT}>
					{renderLoader()}
				</LoaderContainer>
			) : (
				renderLoader()
			)}
		</>
	);
};

export default AggregatePageLoader;
